import { render, staticRenderFns } from "./CantidadVisitas.vue?vue&type=template&id=4e111d9c"
import script from "./CantidadVisitas.vue?vue&type=script&lang=js"
export * from "./CantidadVisitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports